import React from 'react';
import { AddNewAsset } from '../../assets/components/AddNewAsset';
import { Typography } from '@mui/material';
import { SubHeader } from '../mutation/edit/styles';

const AddNewAssetCard = ({ size, openAssetForm, hideTitle }) => {
  return (
    <AddNewAsset
      header={
        !hideTitle &&
        (size === 'thumbnail' ? (
          <Typography variant="body2">Add new offer</Typography>
        ) : (
          <SubHeader>Add new offer</SubHeader>
        ))
      }
      size={size}
      openAssetForm={openAssetForm}
    />
  );
};

export { AddNewAssetCard };
